__turbopack_context__.v({
  "TextContainer": "hhfOCG_TextContainer",
});
